import * as React from "react";
import { Quota } from "../../schema/types/quota";
import { Card } from "antd";
import { CardContent } from "../../components/antd/card/CardContent";
import { quotaHelpers } from "../../mst/kinds/quota.helpers";
import { FormItem } from "../../components/antd/form/FormItem";
import { FormLabel } from "../../components/antd/form/FormLabel";
import { FormItemValue } from "../../components/antd/form/FormItemValue";

interface Props {
  quota: Quota;
}
export const Summary: React.FC<Props> = ({ quota }) => {
  const gvcLink = quotaHelpers.getGvcLink(quota);

  return (
    <div className="cpln-form-section cpln-ant-card-container">
      <Card>
        <CardContent>
          <FormItem>
            <FormLabel>Description</FormLabel>
            <FormItemValue>{quota.description}</FormItemValue>
          </FormItem>
          <FormItem>
            <FormLabel>Current / Max Limit</FormLabel>
            <FormItemValue>{`${quota.current} / ${quota.max}`}</FormItemValue>
          </FormItem>
          {gvcLink ? (
            <FormItem>
              <FormLabel>GVC</FormLabel>
              <FormItemValue>{gvcLink}</FormItemValue>
            </FormItem>
          ) : null}
        </CardContent>
      </Card>
    </div>
  );
};
